import { useState, memo } from "react";
import { ListGroup } from "react-bootstrap";
import { useHistory } from "react-router";
import { Badge } from "antd";
import { useDocumentLink } from "../../../statistics/hooks/use-document-link";
import { useUser } from "../../../../hook";
import { Routes } from "../../../../AppRoutes";
import { useSearchParams } from "../../../../hook/use-search-params";
import { getListIdByStatusValue } from "../../../../services/serviceHelper";

import { documentStatus } from "../../../../constants";
import { getQueryVariable } from "../../../../services/util";
import classNames from "classnames";

const DocumentTabs = ({ setSelectedMenuTextBaseOnStatus }: any) => {
  const [filterExpired, setFilterExpired] = useState(getQueryVariable("filter-expired"));
  const [isOpen] = useState(false);
  const { searchParams, replaceSearchParams } = useSearchParams();
  const statusQuery = searchParams.get("status") || "";
  const [listId, setListId] = useState<any>(getListIdByStatusValue(statusQuery, isOpen));
  const { userAdmin } = useUser();
  const { countNeedProcessDocument } = useDocumentLink();

  const history = useHistory();

  const onMenuItemClick = (status: string | null, isExpired: boolean = false) => {
    if (!status) {
      history.push({ pathname: Routes.document.path, search: `` });
    } else {
      setFilterExpired(isExpired.toString());
      setSelectedMenuTextBaseOnStatus(status);
      searchParams.set("status", status);
      if (isExpired) searchParams.set("filter-expired", "true");
      else searchParams.delete("filter-expired");
      if (status === "tags") searchParams.delete("tags");
      searchParams.delete("folderId");
      replaceSearchParams(searchParams);
    }

    const filterListId = getListIdByStatusValue(status, isOpen);
    if (filterListId !== listId) {
      setListId(filterListId);
    }
  };

  const isAdmin = userAdmin && userAdmin?.id;

  return (
    <ListGroup as="ul" horizontal>
      {isAdmin && (
        <ListGroup.Item key="1" onClick={() => onMenuItemClick(null)} className={classNames({ active: !statusQuery })}>
          Quản lý tài liệu
        </ListGroup.Item>
      )}
      <ListGroup.Item
        key="2"
        onClick={() => onMenuItemClick(documentStatus.publish.value, false)}
        className={classNames({ active: statusQuery === documentStatus.publish.value && filterExpired !== "true" })}
      >
        Tài liệu ban hành
      </ListGroup.Item>
      {isAdmin && (
        <>
          <ListGroup.Item
            key="3"
            onClick={() => onMenuItemClick(documentStatus.compose.value, false)}
            className={classNames({ active: statusQuery === documentStatus.compose.value })}
          >
            Tài liệu đang soạn thảo
          </ListGroup.Item>
          <ListGroup.Item
            key="4"
            onClick={() => onMenuItemClick("approval", false)}
            className={classNames({ active: statusQuery === "approval" })}
          >
            Tài liệu cần duyệt
          </ListGroup.Item>
          <ListGroup.Item
            key="5"
            onClick={() => onMenuItemClick(documentStatus.publish.value, true)}
            className={classNames({ active: statusQuery === documentStatus.publish.value && filterExpired === "true" })}
          >
            Tài liệu lỗi thời
          </ListGroup.Item>
          <ListGroup.Item
            key="7"
            onClick={() => onMenuItemClick(documentStatus.needProcess.value, false)}
            className={classNames({ active: statusQuery === documentStatus.needProcess.value })}
          >
            <Badge count={countNeedProcessDocument || 0} offset={[8, -10]}>
              <span>Tài liệu cần xử lý</span>
            </Badge>
          </ListGroup.Item>
          <ListGroup.Item
            key="8"
            onClick={() => onMenuItemClick(documentStatus.tags.value, false)}
            className={classNames({ active: statusQuery === documentStatus.tags.value })}
          >
            Tài liệu theo chủ đề
          </ListGroup.Item>
        </>
      )}
    </ListGroup>
  );
};

export default memo(DocumentTabs);
